import React, { useState } from 'react';
import './CreateAndMonitor.scss';
import aoiIcon from '../../../assets/icons/aoi-icon-white.png';
import fireIcon from '../../../assets/icons/active-fire-icon.png';

export default function CreateAndMonitor(props) {
    const {
        setPanel
    } = props;

    const [choice, setChoice] = useState(null);

    const choices = [
        {
            title: 'Custom Area',
            description: 'Create and track your own custom Monitoring Area and receive alerts for incidents within its boundaries.',
            img: aoiIcon
        },
        {
            title: 'Add Fire',
            description: 'Input a fire to the map by specifying its location and details, enabling real-time tracking and monitoring.',
            img: fireIcon
        }
    ]

    return (
        <div className='create-and-monitor-page'>
        <div className='create-and-monitor-page-title'>
            <div className='create-and-monitor-page-title-text'>Create and Monitor</div>
        </div>
        <div className='create-and-monitor-page-description'>Customize the map by specifying areas to receive updates for or adding custom fire incidents directly to the application.</div>
        <div className='create-and-monitor-page-content-menu'>
            {choices.map((c) => {
                return (
                    <div 
                        className={`create-and-monitor-page-content-menu-choice ${choice === c.title ? 'selected' : ''}`}
                        onClick={() => setChoice(c.title)}
                        >
                        <div className='create-and-monitor-page-content-menu-choice-title'>
                            <img className='create-and-monitor-page-content-menu-choice-title-icon' src={c.img}/>
                            <div className='create-and-monitor-page-content-menu-choice-title-text'>{c.title}</div>
                        </div>
                        <div className='create-and-monitor-page-content-menu-choice-description'>{c.description}</div>
                    </div>
                )
            })}
            <div 
                className={choice ? 'create-and-monitor-page-content-menu-next-btn' : 'create-and-monitor-page-content-menu-disabled-btn'}
                onClick={() => {
                    if (choice === 'Custom Area') {
                        setPanel({
                            name: 'Monitoring Areas - Create',
                            content: null
                        })
                    } else {
                        setPanel({
                            name: 'Add Fire',
                            content: null
                        })
                    }
                }}
                >Next
            </div>
        </div>
    </div>
    )
}